import { Component } from '@angular/core';
import { STANDARD_CONTENTS, StandardContent } from '../../../../../../../core/utils/products-texts';
import { Router } from '@angular/router';
import { ISummaryData } from '../../../../../../../core/models/summary-data';
import { SummaryService } from '../../../../../../../core/services/summary.service';
import { ProductSelectionService } from '../../../../../../../core/services/product-selection.service';
import { CatalogService } from '../../../../../../../core/services/catalog.service';

@Component({
  selector: 'app-default',
  standalone: false,
  templateUrl: './default.component.html',
  styleUrl: './default.component.scss'
})
export class DefaultComponent {

  selectedItem: any;
  selectedItemCards: any;
  content: StandardContent | undefined;
  summaryData: ISummaryData = {} as ISummaryData;
  productKey: string | undefined;
  totalOrderAmount: number | undefined;

  constructor(private summaryService: SummaryService, private productService: ProductSelectionService, private catalogDataService: CatalogService) {
    const stored = this.summaryService.getSummary();
    if (stored) {
      this.summaryData = stored;
    } else {
      const local = localStorage.getItem('summaryData');
      if (local) {
        this.summaryData = JSON.parse(local);
        this.summaryService.setSummary(this.summaryData);
      } else {
        this.summaryData = {
          productInformation: {}
        };
      }
    }
  }

  ngOnInit(): void {
    const selected = this.productService.getProduct();
    this.totalOrderAmount  = selected?.Price
    this.selectedItem = selected;
    this.selectedItemCards = selected?.relatedCards;
    this.productKey = this.selectedItem?.ProductKey;
    this.content = this.productKey ? STANDARD_CONTENTS[this.productKey] : undefined;
  }

  isNotParkingOrOwnershipChange(): boolean {
    return this.productKey !== 'parking' && this.productKey !== 'ownership-change';
  }

  submitForm(): void {

      this.summaryData = {
        ...this.summaryData,
        productInformation: {
          ZoneId: this.summaryData.productInformation?.ZoneId,
          FinishZoneId: this.summaryData.productInformation?.FinishZoneId,
          icon: this.selectedItem.icon,
          product: this.selectedItem
        },
        serviceConfiguration: { },
      };
  
      this.summaryService.setSummary(this.summaryData);
      this.catalogDataService.emitProductInfo(this.summaryData);
    }
  
}
